import { Link } from "react-router-dom";

export default function FAQSection() {
  const faqs = [
    {
      q: "What is GTBuy Spreadsheet?",
      a: "GTBuy Spreadsheet is a comprehensive spreadsheet system designed for product sourcing and management. It integrates with platforms like Kakobuy and Superbuy to streamline your workflow with automation, real-time data sync, and intelligent categorization.",
    },
    {
      q: "Is Kakobuy Spreadsheet different?",
      a: "Yes, the Kakobuy Spreadsheet is a specific implementation for Kakobuy users. GTBuy Spreadsheet offers broader compatibility with advanced automation features, faster processing, and higher scalability across multiple platforms.",
    },
    {
      q: "Can I integrate Superbuy Spreadsheet?",
      a: "Absolutely. GTBuy Spreadsheet supports seamless integration with Superbuy workflows, giving you a unified dashboard to manage all your product sourcing data in one place.",
    },
    {
      q: "Is it safe for business use?",
      a: "Yes, GTBuy Spreadsheet is built with enterprise-grade security. All data is encrypted, we maintain GDPR compliance, and we never sell or share your data with third parties.",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 text-center mb-2">
          Frequently Asked Questions
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          Everything you need to know about GTBuy Spreadsheet
        </p>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <details
              key={faq.q}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <span className="text-sm font-medium text-foreground-800 pr-4">
                  {faq.q}
                </span>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/article/gtbuy-spreadsheet-guide"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 underline underline-offset-2 transition-colors"
          >
            Read the full GTBuy Spreadsheet Guide &rarr;
          </Link>
        </div>
      </div>
    </section>
  );
}